module.exports = __webpack_public_path__ + "img/festa6.f21e3655.png";